import React from 'react';

type CalendarView = 'day' | 'week';

interface CalendarControlsProps {
  currentDate: Date; // Or string, depending on how you manage it
  view: CalendarView;
  formatDateRange: () => string;
  onNavigatePrev: () => void;
  onNavigateToday: () => void;
  onNavigateNext: () => void;
  onSetView: (view: CalendarView) => void;
}

const CalendarControls: React.FC<CalendarControlsProps> = ({ 
  view, 
  formatDateRange, 
  onNavigatePrev, 
  onNavigateToday, 
  onNavigateNext, 
  onSetView 
}) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
      <div className="flex items-center gap-2">
        <button
          onClick={onNavigatePrev}
          className="p-2 hover:bg-gray-100 rounded"
          aria-label="Previous"
        >
          ◀
        </button>
        <button
          onClick={onNavigateToday}
          className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50 text-sm"
        >
          Today
        </button>
        <button
          onClick={onNavigateNext}
          className="p-2 hover:bg-gray-100 rounded"
          aria-label="Next"
        >
          ▶
        </button>
        <h2 className="text-lg font-medium text-[#344854] ml-2">
          {formatDateRange()}
        </h2>
      </div>
      
      <div className="flex items-center">
        <div className="inline-flex rounded-md shadow-sm" role="group">
          <button
            type="button"
            className={`px-4 py-2 text-sm font-medium rounded-l-lg border ${ // Adjusted class for active state
              view === 'day' 
                ? 'bg-[#3A5E63] text-white border-[#3A5E63]' 
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
            onClick={() => onSetView('day')}
          >
            Day
          </button>
          <button
            type="button"
            className={`px-4 py-2 text-sm font-medium rounded-r-lg border ${ // Adjusted class for active state
              view === 'week' 
                ? 'bg-[#3A5E63] text-white border-[#3A5E63]' 
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            }`}
            onClick={() => onSetView('week')}
          >
            Week
          </button>
          {/* Removed month and resource view buttons */}
        </div>
      </div>
    </div>
  );
};

export default CalendarControls; 